/** My account (phase 2, W4). Merged into the core `conta` namespace. */
export const contaEn = {
  titulo: 'My account',
  kicker: 'Account',
  perfil: 'Profile',
  nome: 'Name',
  email: 'Email',
  aparencia: 'Appearance and language',
  rotuloAbas: 'Account sections',
  abas: { perfil: 'Profile', aparencia: 'Appearance', notificacoes: 'Notifications', seguranca: 'Security', 'meus-dados': 'My data' },
  salvarNome: 'Save name',
  nomeSalvo: 'Name updated',
  nomeVazio: 'Enter your name',
  iniciais: 'Initials of {{nome}}',
  avatar: {
    escolher: 'Choose photo',
    trocar: 'Change photo',
    remover: 'Remove photo',
    ajustar: 'Adjust the photo',
    salvar: 'Save photo',
    descartar: 'Discard',
    salva: 'Photo updated',
    removida: 'Photo removed; your initials are back',
    processando: 'Processing the photo...',
    resultado: 'This is how the photo appears in the system. Save to replace it.',
    resultadoAlt: 'Preview of the new photo',
    removerTitulo: 'Remove the photo?',
    removerTexto: 'Your initials come back. You can choose another photo whenever you want.',
    tipoInvalido: 'Choose a PNG, JPG or WebP image. SVG and other formats are not accepted.',
    grandeDemais: 'File above 20 MB. Choose a smaller image.',
    naoAbriu: 'This image could not be opened. Choose another file.',
    recorte: {
      area: 'Photo crop area',
      ajuda: 'Drag the photo or use the arrow keys (Shift moves further); the mouse wheel and the + and - keys change the zoom. The circle is only a guide to center the face.',
      zoom: 'Zoom',
      saida: 'Output: {{largura}} × {{altura}} px',
      usar: 'Use this crop',
      cancelar: 'Cancel',
      falhou: 'The image could not be generated in this browser. Try another file or another browser.',
    },
  },
  entrada: {
    titulo: 'How you sign in',
    entraCom: 'Signs in with:',
    formas: { ambos: 'e-mail or username, and password', email: 'e-mail and password', usuario: 'username and password' },
    senhaTexto: 'The password is yours: you change it yourself.',
    senhaLink: 'Change the password in Security',
    trocaTexto: 'The e-mail and the username are changed by the workspace administrator: you make the request and they approve or decline it.',
    trocaTextoDireta: 'You change your own e-mail, with your current password. The username is changed by the workspace administrator: you make the request and they approve or decline it.',
    trocaTextoDiretaTudo: 'You change your own e-mail and username, with your current password.',
    semDecisor: 'Your account also belongs to another workspace, and nobody here can approve changing the e-mail or username: ask the platform administrator for the change.',
    acessoLink: 'Change them in Security',
    emailLink: 'Change the e-mail in Security',
    pedirEmail: 'Request a new e-mail',
    pedirAdicionarEmail: 'Request to add an e-mail',
    pedirUsuario: 'Request a new username',
    enviarPedido: 'Send request',
    pedidoEnviado: 'Request sent to the administrator',
    pedidoCancelado: 'Request cancelled',
    cancelarPedido: 'Cancel request',
    aguardando: 'Waiting for the administrator',
    status: { aprovado: 'Approved', recusado: 'Declined' },
    pedido: { email: 'New e-mail: {{valor}}', usuario: 'New username: {{valor}}' },
    motivo: 'Reason: {{motivo}}',
    modal: {
      email: {
        titulo: 'Request a new e-mail',
        texto: 'The administrator receives the request. If approved, we send a confirmation link to the new e-mail; the change only takes effect after you open the link.',
        campo: 'New e-mail',
        ajuda: 'The current e-mail gets a notice when the change is requested and when it is confirmed.',
      },
      usuario: {
        titulo: 'Request a new username',
        texto: 'The administrator receives the request. If approved, the name changes right away and you sign in with it.',
        campo: 'New username',
        ajuda: '2 to 40 letters without accents, numbers, dot, hyphen or underscore, no "@".',
      },
    },
  },
  tour: { titulo: 'System tour', texto: 'Shows the walkthrough of the main areas again.', botao: 'Replay the tour' },
  acessos: {
    titulo: 'My access',
    texto: 'What your roles allow in this workspace, by module.',
    textoSubsistemas: 'What your roles open in this workspace, by subsystem you use and page.',
    vazio: 'You have no permissions in this workspace yet. Talk to the administrator.',
    modulos_one: '{{count}} module',
    modulos_other: '{{count}} modules',
  },
  notificacoes: {
    titulo: 'Notifications',
    texto: 'Notification preferences live on their own screen, which comes with the alerts center.',
  },
  fonte: {
    titulo: 'Text font',
    texto: 'Pick the text font just for you. Numbers and amounts stay in the fixed width font, so columns stay aligned.',
    doWorkspace: 'The workspace one',
    doWorkspaceNome: 'The workspace one ({{nome}})',
    doEstiloNome: 'The style one ({{nome}})',
    sistema: 'System font',
    enviada: 'Uploaded by the administrator',
    bloqueada: 'The administrator set the same font for everyone in this workspace.',
    amostra: 'Quick action: code Il1O0, 25 items, 98.5%, ñ ¿ ¡',
    facilLer: 'Easier to read',
    escala: 'Text size',
    escalaAjuda: 'Makes all the text on screen bigger, for easier reading.',
    salva: 'Preference saved',
  },
  estilo: {
    titulo: 'Style',
    texto: 'Choose the look of the system just for you. Tide, Ice and Malgo bring the brand colors; the other styles change corners, font, effects, depth and shadows, inspired by public design systems.',
    seguirPadrao: 'Workspace default',
    fixado: 'Your administrator set the {{nome}} style for your account.',
    bloqueado: 'Your administrator set the same style for everyone in this workspace: {{nome}}.',
    padrao: 'Default',
    nomes: {
      mare_malgo: 'Tide',
      gelo: 'Ice',
      malgo: 'Malgo (current)',
      proprio: 'Custom model',
      cupertino: 'Cupertino (inspired by Apple)',
      mare: 'Navy (inspired by RD Station)',
      redmond: 'Redmond (inspired by Microsoft)',
      mountain_view: 'Mountain View (inspired by Google)',
      armonk: 'Armonk (inspired by IBM)',
      embarcadero: 'Embarcadero (inspired by Salesforce)',
      sydney: 'Sydney (inspired by Atlassian)',
      grafite: 'Grafite (inspired by GitHub)',
      ottawa: 'Ottawa (inspired by Shopify)',
    },
    salvo: 'Style saved',
  },
  simples: {
    titulo: 'Simple mode',
    ajuda: 'Hides the advanced tabs and fields, leaving only what you use every day. Nothing is deleted and you can turn it off any time.',
    desligado: 'Off',
    ligado: 'On',
  },
  seguranca: {
    senha: {
      titulo: 'Password',
      atual: 'Current password',
      nova: 'New password',
      confirmar: 'Confirm new password',
      ajuda: 'Use at least 10 characters. When you change it, other devices are signed out.',
      trocar: 'Change password',
      diferentes: 'The passwords do not match',
      trocada_zero: 'Password changed. No other device had your account open.',
      trocada_one: 'Password changed. {{count}} other device was signed out.',
      trocada_other: 'Password changed. {{count}} other devices were signed out.',
    },
    mfa: {
      titulo: 'Two-step verification',
      texto: 'Besides the password, sign in asks for a 6 digit code from the authenticator app (Google Authenticator, Microsoft Authenticator, 1Password or another).',
      ativa: 'On',
      inativa: 'Off',
      obrigatoria: 'Your role requires two-step verification. Set it up by {{data}}.',
      obrigatoriaAgora: 'Your role requires two-step verification. Set it up now to continue.',
      lembreteLogin: 'Your role requires two-step verification. Set it up by {{data}} in My account > Security.',
      obrigatoriaAtiva: 'Required for your role',
      ativar: 'Turn on',
      passo1: 'Scan the QR code with the authenticator app.',
      passo1Alt: 'No camera? Type this key in the app:',
      passo2: 'Enter the 6 digit code the app shows.',
      codigo: 'App code',
      codigoOuBackup: 'App code or backup code',
      confirmarAtivar: 'Confirm and turn on',
      encerrarOutras: 'Sign out of other sessions (other devices sign in again with the code)',
      qrRotulo: 'QR code for the authenticator app',
      chave: 'Key',
      backupsTitulo: 'Backup codes',
      backupsTexto: 'Keep these codes somewhere safe. Each one works once, to sign in without your phone. They will not be shown again.',
      copiarCodigos: 'Copy codes',
      guardei: 'I saved the codes',
      backupsRestantes_one: '{{count}} backup code left',
      backupsRestantes_other: '{{count}} backup codes left',
      novosBackups: 'Generate new backup codes',
      novosBackupsTexto: 'The previous codes stop working. Enter an app code to confirm.',
      trocarAparelho: 'Switch device',
      trocarAparelhoTexto: 'Enter a code from the current app. Then scan the new QR code on the new device.',
      desativar: 'Turn off',
      desativarTexto: 'Enter an app code or a backup code to turn it off.',
      ativada: 'Two-step verification turned on',
      desativada: 'Two-step verification turned off',
      continuar: 'Continue',
    },
    sessoes: {
      titulo: 'Active sessions',
      texto: 'Devices with your account open right now.',
      esteAparelho: 'This device',
      sair: 'Sign out of this device',
      sairTodos: 'Sign out of all other devices',
      sairTodosTexto: 'The other devices are signed out right away. This one stays open.',
      ultimoUso: 'Last used: {{quando}}',
      desconhecido: 'Unknown device',
      movel: 'phone',
      ip: 'IP {{ip}}',
      soEste: 'Only this device has your account open.',
      encerrada: 'Device signed out',
      encerradas_zero: 'No other device had your account open',
      encerradas_one: '{{count}} device signed out',
      encerradas_other: '{{count}} devices signed out',
    },
    acesso: {
      titulo: 'Account access',
      texto: 'You sign in with the e-mail or with the username, always with the same password. The account is the same in every company you work for.',
      usuario: 'Username',
      email: 'E-mail',
      semEmail: 'No e-mail',
      semEmailTexto: 'Without an e-mail, password and two-step verification recovery is with the administrator, and security notices arrive in Notifications.',
      trocarEmail: 'Change e-mail',
      adicionarEmail: 'Add e-mail',
      emailNovo: 'New e-mail',
      emailNovoAjuda: 'We send a link to it. The change only takes effect after the confirmation; the current e-mail gets a notice.',
      emailInvalido: 'Enter a valid e-mail',
      enviar: 'Send confirmation link',
      enviado: 'If the address can be used, we sent the link to it. The change only takes effect after the confirmation.',
      trocarUsuario: 'Change username',
      usuarioNovo: 'New username',
      usuarioNovoAjuda: 'From 2 to 40 unaccented letters, numbers, period, hyphen or underscore, no "@". It takes effect right away; the current one stops working.',
      usuarioInvalido: 'The username cannot have "@"',
      salvarUsuario: 'Save username',
      usuarioTrocado: 'Username changed',
    },
    trocaObrigatoria: {
      titulo: 'Change the temporary password',
      texto: 'The password you got from the administrator is only for the first sign in. Choose your password to continue. Your username: {{usuario}}.',
    },
    forcada: {
      titulo: 'Set up two-step verification',
      texto: 'Your role requires a second step at sign in. Set it up now to keep using the system.',
    },
  },
};
